import { GmailPostmasterRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsGmailPostmasterRoute() {
  const { workspaceId } = Route.useParams();
  return <GmailPostmasterRoute segment="reports" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/gmail-postmaster')({
  component: ReportsGmailPostmasterRoute,
});
